import {Box, Grid, Link} from "@mui/material"
import {Paper, Typography} from "@mui/material";
import {CardContent} from "@material-ui/core";
import FacebookIcon from '@mui/icons-material/Facebook';
import EmailIcon from '@mui/icons-material/Email';
import learners from "../assets/learners.jpg";
import logo from "../assets/logo.png";
import edensol from "../assets/edensol.png";
import eurosuccess from "../assets/euro.jpg";
import polska from "../assets/polska.png";
import slovenia from "../assets/slovenia.png";
import ugd from "../assets/ugd.png";
import upi from "../assets/upi.png";
import {useTranslation} from "react-i18next";

const ContactPage = () => {
    const {t} = useTranslation();

    const partners = [
        {
            "img": edensol,
            "img_alt": t("edensol_alt"),
            "txt": t("edensol_txt"),
            "url": "https://www.edensol.eu",
            "country": t("spain")
        },
        {
            "img": slovenia,
            "img_alt": t("utzo_alt"),
            "txt": t("utzo_txt"),
            "url": "https://www.utzo.si",
            "country": t("slovenia")
        },
        {
            "img": eurosuccess,
            "img_alt": t("eurosuccess_alt"),
            "txt": t("eurosuccess_txt"),
            "url": "https://www.eurosc.eu",
            "country": t("cyprus")
        },
        {
            "img": upi,
            "img_alt": t("upi_alt"),
            "txt": t("upi_txt"),
            "url": "https://www.upi.si",
            "country": t("slovenia")
        },
        {
            "img": ugd,
            "img_alt": t("ugd_alt"),
            "txt": t("ugd_txt"),
            "url": "https://www.ugd.edu.mk",
            "country": t("macedonia")
        },
        {
            "img": polska,
            "img_alt": t("oic_lublin_alt"),
            "txt": t("oic_lublin_txt"),
            "url": "https://www.oic.lublin.pl",
            "country": t("poland")
        },
    ];

    const partnerContainers = partners.map(partner =>
        <Grid item container justifyContent="center" alignItems="center" spacing={1} xs={12}>
            <Grid item container xs={5}>
                <img src={partner["img"]} style={{maxHeight: 150, maxWidth: "100%"}}
                     alt={partner["img_alt"]}/>
            </Grid>
            <Grid item xs={4}>
                <Typography>{partner["txt"]}</Typography>
                <Link href={partner["url"]}>{partner["url"]}</Link>
            </Grid>
            <Grid item xs={3}><Typography align="right">{partner["country"]}</Typography></Grid>
        </Grid>
    );

    return (
        <Box sx={{m: 2}}>
            <Grid container>
                <Paper elevation={6}>
                    <CardContent>
                        <Grid container spacing={1}>
                            <Grid item container justifyContent="center" xs={12}>
                                <Typography variant="h3">{t("contact")}</Typography>
                            </Grid>
                            <Grid item xs={12}>
                                <Typography align="justify" variant="h6">
                                    {t("project_details")}
                                </Typography>
                            </Grid>
                            <Grid item xs={12}>
                                <Typography align="justify">
                                    {t("contact_p1")}
                                </Typography>
                            </Grid>
                            <Grid item xs={12}>
                                <Typography align="justify">
                                    {t("project_number")}: 2020-1-ES01-KA204-081775
                                </Typography>
                            </Grid>
                            <Grid item xs={12}>
                                <Typography>{t("website")}: <a href="https://learnersmot2.eu">https://learnersmot2.eu</a>
                                </Typography>
                            </Grid>
                            <Grid item xs={12}>
                                <div style={{display: "flex", alignItems: "center", flexWrap: "nowrap"}}>
                                    <FacebookIcon/>
                                    <Typography sx={{ml: .5}}>
                                        {t("facebook")}: <a href="https://www.facebook.com/Learners-Mot-2-102421268497592">
                                        https://www.facebook.com/Learners-Mot-2-102421268497592</a>
                                    </Typography>
                                </div>
                            </Grid>
                            <Grid item xs={12}>
                                <div style={{display: "flex", alignItems: "center", flexWrap: "nowrap"}}>
                                    <EmailIcon/>
                                    <Typography sx={{ml: .5}}>
                                        {t("email_address")}: <a href="learnersmot2@gmail.com">learnersmot2@gmail.com</a>
                                    </Typography>
                                </div>
                            </Grid>

                            <Grid item container justifyContent="center" alignItems="center" xs={12} sx={{my: 2}}
                                  spacing={1}>
                                <Grid item container xs={6} justifyContent="center" alignItems="center">
                                    <img src={learners} alt={t("lm2_logo_alt")}
                                         style={{width: "100%", maxWidth: 312, maxHeight: 173}}/>
                                </Grid>
                                <Grid item container xs={6}>
                                    <img src={logo} alt={t("erasmus_programme_alt")}
                                         style={{width: "100%", maxWidth: 473, maxHeight: 133}}/>
                                </Grid>
                            </Grid>

                            <Grid item xs={12}>
                                <Typography align="center" variant="h6">
                                    {t("project_consortium")}
                                </Typography>
                            </Grid>

                            <Grid item container xs={12} spacing={3}>
                                {partnerContainers}
                            </Grid>
                        </Grid>
                        {/*<Grid container justifyContent="left" alignItems="center" spacing={2}>*/}
                        {/*    <ContactForm/>*/}
                        {/*</Grid>*/}
                    </CardContent>
                </Paper>
            </Grid>
        </Box>
    );
};

export default ContactPage;